import { render, staticRenderFns } from "./OnlinePaymentLanding.vue?vue&type=template&id=ff5af414"
import script from "./OnlinePaymentLanding.vue?vue&type=script&lang=js"
export * from "./OnlinePaymentLanding.vue?vue&type=script&lang=js"
import style0 from "./OnlinePaymentLanding.vue?vue&type=style&index=0&id=ff5af414&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports